import cn from 'classnames'
import dynamic from 'next/dynamic'
import { HTMLAttributes } from 'react'
// import { Header } from 'src/components/Header/Header'
import { IltaFooter } from 'src/components/IltaFooter/IltaFooter'
import SkeletonLoading from 'src/components/SkeletonLoading/SkeletonLoading'

import { ThemeOnly } from '../ThemeOnly'
import styles from './MainContainer.module.css'

const Header = dynamic(() => import('src/components/Header/Header').then((mod) => mod.Header), {
  suspense: true,
  loading: () => <SkeletonLoading className="bg-navy" />,
})
const MainContainer = ({ children, className, ...props }: HTMLAttributes<HTMLDivElement>) => (
  <div className={cn(className, styles.mainContainer)} {...props}>
    <ThemeOnly theme="legaltech">
      <Header />
    </ThemeOnly>
    {children}
    <ThemeOnly theme="ilta">
      <IltaFooter />
    </ThemeOnly>
  </div>
)

export default MainContainer
